import { SVG_ICONS } from "../components/__common/Svg/Svg";
import { GpsRegion, GPS_REGION_CODE } from "../types/gps-region";

export const GpsRegions: GpsRegion[] = [
  {
    code: GPS_REGION_CODE.LATIN_AMERICA,
    name: "Latin America",
    image: SVG_ICONS.GPS_MAP_LATIN_AMERICA,
    countries: [
      {
        code: "AR",
        name: "Argentina",
        link: "https://sdapla.privacy.samsung.com/privacy/ar",
      },
      {
        code: "BO",
        name: "Bolivia",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "BR",
        name: "Brasil ",
        link: "https://www.samsung.com/br/privacy/",
      },
      {
        code: "CL",
        name: "Chile",
        link: "https://sdapla.privacy.samsung.com/privacy/cl",
      },
      {
        code: "CO",
        name: "Colombia",
        link: "https://sdapla.privacy.samsung.com/privacy/co",
      },
      {
        code: "CR",
        name: "Costa Rica",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "EC",
        name: "Ecuador",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "SV",
        name: "El Salvador",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "GT",
        name: "Guatemala",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "HN",
        name: "Honduras",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "MX",
        name: "México",
        link: "https://sdapla.privacy.samsung.com/privacy/mx",
      },
      {
        code: "NI",
        name: "Nicaragua",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "PA",
        name: "Panamá",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "PY",
        name: "Paraguay",
        link: "https://sdapla.privacy.samsung.com/privacy/py",
      },
      {
        code: "PE",
        name: "Perú",
        link: "https://sdapla.privacy.samsung.com/privacy/pe",
      },
      {
        code: "DO",
        name: "República Dominicana",
        link: "https://sdapla.privacy.samsung.com/privacy/latin",
      },
      {
        code: "UY",
        name: "Uruguay",
        link: "https://sdapla.privacy.samsung.com/privacy/uy",
      },
    ],
  },
  {
    code: GPS_REGION_CODE.NORTH_AMERICA,
    name: "North America",
    image: SVG_ICONS.GPS_MAP_NORTH_AMERICA,
    countries: [
      { code: "USA", name: "USA", link: "https://www.samsung.com/us/privacy/" },
    ],
  },
  {
    code: GPS_REGION_CODE.ASIA_PACIFIC,
    name: "Asia Pacific",
    image: SVG_ICONS.GPS_MAP_ASIA,
    countries: [
      // {
      //   code: "AU",
      //   name: "Australia",
      //   link: "https://www.samsung.com/au/privacy-support/",
      // },
      {
        code: "CHN",
        name: "中國",
        link: "https://privacy.samsung.com.cn/",
      },
      // {
      //   code: "ID",
      //   name: "Indonesia",
      //   link: "https://www.samsung.com/id/privacy-support/#",
      // },
      // {
      //   code: "MY",
      //   name: "Malaysia",
      //   link: "https://www.samsung.com/my/privacy-support/#",
      // },
      // {
      //   code: "NZ",
      //   name: "New Zealand",
      //   link: "https://www.samsung.com/nz/privacy-support/",
      // },
      // {
      //   code: "PH",
      //   name: "Philippines",
      //   link: "https://privacy.samsung.com.cn/",
      // },
      // {
      //   code: "SG",
      //   name: "Singapore",
      //   link: "https://www.samsung.com/sg/privacy-support/#",
      // },
      // {
      //   code: "TH",
      //   name: "ประเทศไทย",
      //   link: "https://www.samsung.com/th/privacy-support/#",
      // },
      // {
      //   code: "VN",
      //   name: "Việt Nam",
      //   link: "https://www.samsung.com/vn/privacy-support/#",
      // },
    ],
  },
  {
    code: GPS_REGION_CODE.EUROPE,
    name: "Europe",
    image: SVG_ICONS.GPS_MAP_EUROPE,
    countries: [
      {
        code: "ALB",
        name: "Shqipëri ",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "AUT",
        name: "Österreich",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "BEL",
        name: "Belgium",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "BGR",
        name: "България",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "HRV",
        name: "Hrvatska",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "CZE",
        name: "Česká republika",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "DNK",
        name: "Danmark",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "EST",
        name: "Estonian",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "FIN",
        name: "Suomi",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "FRA",
        name: "France",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "DEU",
        name: "Deutschland",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "GRC",
        name: "Ελλάδα",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "HUN",
        name: "Magyarország",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "ISL",
        name: "Iceland",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "IRL",
        name: "Ireland",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "ITA",
        name: "Italia",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "LVA",
        name: "Latvija",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "LTU",
        name: "Lietuva",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "LUX",
        name: "Luxembourg",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "MLT",
        name: "Malta",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "NLD",
        name: "Nederland",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "NOR",
        name: "Norge",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "POL",
        name: "Polska",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "PRT",
        name: "Portugal",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "ROU",
        name: "Romania",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "SRB",
        name: "Cрбија",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "SVK",
        name: "Slovensko",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "SVN",
        name: "Slovenija ",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "ESP",
        name: "Espana",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "SWE",
        name: "Sverige",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "CHE",
        name: "Schweiz",
        link: "https://www.samsung.com/request-desk",
      },
      {
        code: "TUR",
        name: "Türkiye",
        link: "https://kvkk-portal.samsung.com/",
      },
      {
        code: "GBR",
        name: "UK",
        link: "https://www.samsung.com/request-desk",
      },
    ],
  },
];
